import { render } from "./PhotoUploadArea.vue?vue&type=template&id=3ee116be&scoped=true"
import script from "./PhotoUploadArea.vue?vue&type=script&lang=js"
export * from "./PhotoUploadArea.vue?vue&type=script&lang=js"

import "./photo-upload-area.scss?vue&type=style&index=0&id=3ee116be&lang=scss&scoped=true"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee116be"]])

export default __exports__